exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.faded[data-v-b9e74e3e] {\n}\n.focused[data-v-b9e74e3e] {\n}\n", ""]);

// exports
